import { render } from "./PlayMeldIcon.vue?vue&type=template&id=b9ff3b9a&scoped=true"
import script from "./PlayMeldIcon.vue?vue&type=script&lang=js"
export * from "./PlayMeldIcon.vue?vue&type=script&lang=js"

import "./PlayMeldIcon.vue?vue&type=style&index=0&id=b9ff3b9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ff3b9a"]])

export default __exports__